import { useMutation } from '@tanstack/react-query'
import { getPaymentOrderRequests } from '../../service/payment'

function useGetPaymentOrderRequests() {
  return useMutation({
    mutationKey: ['get-payment-order-requests'],
    mutationFn: getPaymentOrderRequests,
  })
}

export default useGetPaymentOrderRequests
